import React from "react";
import { Box, Button, Grid, LinearProgress } from "@material-ui/core";
import TextFieldHelper from "../../UI/FormHelper/TextFieldHelper";
import CarContractItems from "./CarContractItems";
import FormHeaderPart from "../../UI/FormHeaderPart/FormHeaderPart";
import FieldDatePicker from "../../Form/FieldDatePicker";
import UserAutoComplete from "../../Form/UserAutoComplete";
import Wrapper from "../../../hoc/Wrapper/Wrapper";
import FieldDateTimePicker from "../../Form/FieldDateTimePicker";

const CarContractAddFormFields = (props) => {
  const {
    values,
    touched,
    handleChange,
    isValid,
    setFieldTouched,
    setFieldValue,
    handleClose,
    handleSubmit,
    errors,
  } = props;

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <Grid container>
          <Grid item xs={12} md={6}>
            <Box p={1}>
              <FieldDatePicker
                label={"تاریخ سند"}
                fieldName={"document_date"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"شماره سند"}
                fieldName={"document_number"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"نوع معامله"}
                fieldName={"document_type"}
                {...props}
                select={true}
                options={[
                  { value: "purchase", label: "خرید نقدی" },
                  { value: "installment_purchase", label: "خرید اقساطی" },
                  { value: "sale", label: "فروش نقدی" },
                  { value: "installment_sale", label: "فروش اقساطی" },
                ]}
              />
            </Box>
          </Grid>

          <FormHeaderPart title={"اطلاعات اتومبیل"} />
          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"نوع خودرو"}
                fieldName={"car_type"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"رنگ خودرو"}
                fieldName={"car_color"}
                {...props}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={12}>
            <Box p={1}>
              <TextFieldHelper
                title={"سال ساخت خودرو"}
                fieldName={"manufacture_date"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"شماره انتظامی فعلی"}
                fieldName={"current_tag"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"شماره انتظامی بعدی"}
                fieldName={"next_tag"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"شماره شاسی"}
                fieldName={"chassis_number"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"شماره موتور"}
                fieldName={"motor_number"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"vin"}
                fieldName={"vin_number"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"بارکد کارت ماشین"}
                fieldName={"barcode"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"شرکت بیمه"}
                fieldName={"insurance_company"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"شماره بیمه"}
                fieldName={"insurance_id"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"شماره یکتای بیمه"}
                fieldName={"insurance_unique_id"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <FieldDatePicker
                label={"تاریخ انقضا بیمه"}
                fieldName={"insurance_expire_date"}
                {...props}
              />
            </Box>
          </Grid>

          <FormHeaderPart title={"اطلاعات خرید"} />

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <UserAutoComplete
                title={"فروشنده"}
                fieldName={"seller_id"}
                setFieldValue={setFieldValue}
                fieldNameShow={"seller_fullname"}
                value={values.seller_fullname}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <UserAutoComplete
                title={"خریدار"}
                fieldName={"buyer_id"}
                setFieldValue={setFieldValue}
                fieldNameShow={"buyer_fullname"}
                value={values.buyer_fullname}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <FieldDateTimePicker
                label={"تاریخ تحویل"}
                fieldName={"delivery_date"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"مرکز کارشناسی "}
                fieldName={"inspection_center"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <FieldDateTimePicker
                label={"تاریخ کارشناسی"}
                fieldName={"inspection_date"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box display={"flex"}>
              <CarContractItems
                field={"delivered_items"}
                value={values.delivered_items}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box p={1}>
              <TextFieldHelper
                title={"سایر توضیحات "}
                fieldName={"notes"}
                multiline={true}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box p={1}>
              <TextFieldHelper
                title={"دفترخانه"}
                fieldName={"office"}
                multiline={true}
                {...props}
              />
            </Box>
          </Grid>

          <FormHeaderPart title={"شرایط پرداخت"} />

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"کل ثمن معامله"}
                fieldName={"price"}
                isNumber={true}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"پیش پرداخت"}
                fieldName={"prepayment"}
                isNumber={true}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"مابقی ثمن معامله"}
                fieldName={"remained"}
                isNumber={true}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"میزان سود"}
                fieldName={"profit"}
                isNumber={true}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"تعداد چک"}
                fieldName={"cheques"}
                isNumber={true}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box p={1}>
              <TextFieldHelper
                title={"جزئیات پرداخت"}
                fieldName={"payment_terms"}
                multiline={true}
                {...props}
              />
            </Box>
          </Grid>

          {props.isEdit ? (
            <Wrapper>
              <Grid item xs={12} md={6}>
                <Box p={1}>
                  <TextFieldHelper
                    title={"تاریخ ویرایش"}
                    fieldName={"updated_at"}
                    {...props}
                    disabled={true}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box p={1}>
                  <TextFieldHelper
                    title={"تاریخ ثبت"}
                    fieldName={"created_at"}
                    disabled={true}
                    {...props}
                  />
                </Box>
              </Grid>
            </Wrapper>
          ) : null}
        </Grid>

        <Box mt={2}>
          {props.loading ? (
            <Wrapper>
              <Button
                fullwidth={true}
                size={"large"}
                disabled={true}
                color={"default"}
              >
                در حال ارسال
              </Button>
              <LinearProgress />
            </Wrapper>
          ) : (
            <Button
              variant={"contained"}
              type="submit"
              size={"large"}
              fullWidth={true}
              color={"primary"}
            >
              {props.isEdit ? "ثبت ویرایش" : "افزودن معامله"}
            </Button>
          )}
        </Box>
      </form>
    </div>
  );
};

export default CarContractAddFormFields;
